var HeaderVariable = {


	mvtEnCours:false,
	intervalMvt:0,
	attenuation:4,
	amplitude_scroll:500,

	currentSize:100,
	sizeDest:0,


	init:function(){
		$(window).scroll(function(){
			HeaderVariable.defineHeaderSize($(window).scrollTop());
		});

		HeaderVariable.defineHeaderSize($(window).scrollTop());

	},

	defineHeaderSize:function($val){

		//console.log("DEFINE HEADER : " + $val);

		HeaderVariable.sizeDest = Math.min(100, ($val / HeaderVariable.amplitude_scroll) * 100);

		if(HeaderVariable.mvtEnCours == false){
			HeaderVariable.mvtEnCours = true;
			HeaderVariable.attenuationMouvement();
		}

	}, 
	attenuationMouvement:function(){
		var _size_temp = Math.round((HeaderVariable.currentSize + (HeaderVariable.sizeDest - HeaderVariable.currentSize) / HeaderVariable.attenuation)*100)/100;
		//console.log("Attenuation mouvement Scroll : current = " + HeaderVariable.currentSize + " -> dest = " + HeaderVariable.sizeDest + "   / temp = " + _size_temp);


		if(Math.abs(_size_temp - HeaderVariable.sizeDest) > 1){
			HeaderVariable.change_headerSize(_size_temp);

			clearTimeout(HeaderVariable.intervalMvt);			
			HeaderVariable.intervalMvt = setTimeout(function(){
				HeaderVariable.attenuationMouvement();
			}, 20);

		}else{

			clearTimeout(HeaderVariable.intervalMvt);
			HeaderVariable.change_headerSize(HeaderVariable.sizeDest);
			HeaderVariable.mvtEnCours = false;
		}

	},
	change_headerSize:function($val){

		HeaderVariable.currentSize = $val;	

		$(".header-variable").each(function(){

			var _property = $(this).attr("data-prop");
			var _min = parseInt($(this).attr("data-min"));
			var _max = parseInt($(this).attr("data-max") );
			var _temp =  Math.round((_min + (($val/100) * (_max - _min)))*100)/100;

			var _mouvement = true;
			
			if(_mouvement == true){
				switch(_property){
					case "height":
						$(this).css({height:_temp});
						break;
					case "opacity":

						$(this).css({opacity:_temp});
						break;
					case "font-size":
						$(this).css({"font-size":_temp+"px"});
						break;
					case "line-height":
						$(this).css({"line-height":_temp+"px"});
						break;
					case "padding-h":

						$(this).css({"padding-top":_temp+"px", "padding-bottom":_temp+"px"});
						break;
					case "top":

						$(this).css({top:_temp+"px"});
						break;
												}
			}


			if($val != 0){
				$(".header").addClass("shadow");
			}else{
				$(".header").removeClass("shadow");
			}

		});

	}	
}

$(document).ready(function(){
	if($(".header-variable").length){
		HeaderVariable.init();
	}
})